import { useConfirmBeforeUnload } from './useConfirmBeforeUnload';
import { useConfirmOnBrowserBack } from './useConfirmOnBrowserBack';

type ConfirmLeavePageOptions = {
	enabled?: boolean;
	message?: string;
	confirmOnBrowserBack?: boolean;
	confirmOnUnload?: boolean;
};

export function useConfirmLeavePage(options: ConfirmLeavePageOptions = {}) {
	const {
		enabled = true,
		message,
		confirmOnBrowserBack = true,
		confirmOnUnload = true,
	} = options;

	useConfirmOnBrowserBack(enabled && confirmOnBrowserBack, message);
	useConfirmBeforeUnload(enabled && confirmOnUnload, message);
}
